(function () {
  // First <button> in open shadow trees under container (recursive light + shadow walk).
  function findButtonInOpenShadowRoots(container) {
    if (!container) {
      return null;
    }

    function search(node) {
      if (!node) {
        return null;
      }

      const shadow = node.shadowRoot;
      if (shadow) {
        const direct = shadow.querySelector('button');
        if (direct) {
          return direct;
        }
        const shadowEls = shadow.querySelectorAll('*');
        for (let i = 0; i < shadowEls.length; i += 1) {
          const nested = search(shadowEls[i]);
          if (nested) {
            return nested;
          }
        }
      }

      const kids = node.children;
      if (!kids) {
        return null;
      }
      for (let j = 0; j < kids.length; j += 1) {
        const found = search(kids[j]);
        if (found) {
          return found;
        }
      }
      return null;
    }

    return search(container);
  }

  function injectShadowStylesheet(shadowRoot, href) {
    if (!href || !shadowRoot || !(shadowRoot instanceof ShadowRoot)) {
      return;
    }
    if (shadowRoot.querySelector('link[rel="stylesheet"][data-wls-bread-shadow]')) {
      return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-wls-bread-shadow', '');
    shadowRoot.prepend(link);
  }

  // Callback once when that button exists (observer + short poll; Bread mounts async).
  function onFinancingShadowButton(container, callback) {
    let settled = false;
    const run = () => {
      if (settled) {
        return true;
      }
      const btn = findButtonInOpenShadowRoots(container);
      if (btn) {
        settled = true;
        callback(btn);
        return true;
      }
      return false;
    };

    if (run()) {
      return;
    }

    const obs = new MutationObserver(() => {
      if (run()) {
        obs.disconnect();
        if (pollId) {
          clearInterval(pollId);
        }
      }
    });
    obs.observe(container, { childList: true, subtree: true });

    let attempts = 0;
    const pollId = setInterval(() => {
      if (run() || attempts >= 50) {
        clearInterval(pollId);
        obs.disconnect();
      }
      attempts += 1;
    }, 100);
  }

  function money(value, currency) {
    return { value, currency };
  }

  function buildOrder(root) {
    const price = parseInt(root.dataset.price, 10);
    const currency = root.dataset.currency || 'USD';
    if (Number.isNaN(price)) {
      return null;
    }

    const item = {
      name: root.dataset.productTitle || '',
      sku: root.dataset.sku || '',
      category: root.dataset.category || 'General',
      unitPrice: money(price, currency),
      unitTax: money(0, currency),
      brand: root.dataset.brand || '',
      quantity: 1,
      shippingDescription: root.dataset.shippingDescription || 'Ground Shipping',
      shippingProvider: root.dataset.shippingProvider || 'UPS',
      shippingCost: money(0, currency),
    };

    return {
      items: [item],
      subTotal: money(price, currency),
      totalTax: money(0, currency),
      totalShipping: money(0, currency),
      totalDiscounts: money(0, currency),
      totalPrice: money(price, currency),
    };
  }

  function buildPlacement(root) {
    const domID = root.dataset.checkoutDomId || 'bread-checkout-btn-1';
    const order = buildOrder(root);
    if (!order) {
      return null;
    }
    return {
      domID,
      allowCheckout: false,
      order,
    };
  }

  const roots = document.querySelectorAll('[data-wls-bread-pay]');
  if (!roots.length || typeof BreadPayments === 'undefined') {
    return;
  }

  const integrationKey = 'f6c66a69-1112-4aba-b7d8-b2d7e5cb9417';
  if (!integrationKey) {
    return;
  }

  BreadPayments.setup({ integrationKey });

  const placements = [];
  roots.forEach((root) => {
    const p = buildPlacement(root);
    if (p) {
      placements.push(p);
    }
  });

  if (placements.length) {
    BreadPayments.registerPlacements(placements);
  }

  document.querySelectorAll('.wls-buybox__financing').forEach((financing) => {
    onFinancingShadowButton(financing, (button) => {
      financing.wlsBreadShadowButton = button;
      const shadowRoot = button.getRootNode();
      injectShadowStylesheet(shadowRoot, financing.dataset.wlsBreadShadowCss);
    });
  });

  BreadPayments.on('INSTALLMENT:APPLICATION_DECISIONED', (installmentResult) => {
    console.log(installmentResult);
  });
  BreadPayments.on('INSTALLMENT:APPLICATION_CHECKOUT', (installmentResult) => {
    console.log(installmentResult);
  });
})();
